import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/js/scripts';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, createHashRouter, RouterProvider} from "react-router-dom";

// ..... Pages .......
import Home from "./pages/home/home";
import Notfound from "./pages/not-found/not-found";
import UseCase from "./pages/use-case/marketing/use-case";
import Pricing from "./pages/pricing/pricing";
import Blogs from "./pages/blogs/blogs";
import BlogDetails from "./pages/blog-details/blog-details";
import Sales from "./pages/use-case/sales/sales";
import CustomerSuccess from "./pages/use-case/customer-success/customer-success";
import Support from "./pages/use-case/support/support";
import Training from "./pages/use-case/training/training";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createHashRouter([
   {
      path: '/',
      element: <App/>,
      errorElement: <Notfound/>,
      children: [
         {
            path: 'home',
            element: <Home/>
         },
         {
            path: 'useCase',
            element: <UseCase/>
         },
         {
            path: 'sales',
            element: <Sales/>
         },
         {
            path: 'customer-success',
            element: <CustomerSuccess />
         },
         {
            path: 'support',
            element: <Support />
         },
         {
            path: 'training',
            element: <Training />
         },
         {
            path: 'pricing',
            element: <Pricing/>
         },
         {
            path: 'blogs',
            element: <Blogs/>
         },
         {
            path: 'blogs-details',
            element: <BlogDetails/>
         }
      ]
   }
])

root.render(
    <React.StrictMode>
       <RouterProvider router={router}/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
